// English strings. Keys are shared with nl.ts; `{name}` is filled in by t().
const en = {
  "app.name": "DamaTrainer",
  "nav.train": "Train",
  "nav.dashboard": "Dashboard",
  "nav.modules": "Modules",
  "nav.leaderboard": "Leaderboard",
  "nav.favorites": "Favorites",
  "nav.history": "History",
  "nav.admin": "Admin",
  "nav.profile": "Profile",
  "nav.login": "Log in",
  "nav.logout": "Log out",
  "nav.signup": "Sign up",
  "nav.theme": "Light / dark",

  "landing.title": "Find the combination.",
  "landing.lead": "Draughts shots at exactly your level. Your rating moves with every exercise, and the site tells you - nicely - when you got it right.",
  "landing.start": "Start training",
  "landing.try": "Try this one: white to play and win.",
  "landing.taster_done": "Create an account to keep your rating.",

  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Display name",
  "auth.login": "Log in",
  "auth.signup": "Create account",
  "auth.forgot": "Forgot password?",
  "auth.no_account": "No account yet?",
  "auth.have_account": "Already have an account?",
  "auth.send_reset": "Send reset link",
  "auth.reset_sent": "If that address has an account, a link is on its way.",
  "auth.new_password": "New password",
  "auth.set_password": "Set password",
  "auth.reset_done": "Password changed. You can log in now.",
  "auth.verified": "Thanks, your email address is confirmed.",
  "auth.verify_failed": "This link is not valid (any more).",
  "auth.verify_hint": "Check your inbox to confirm your email address.",

  "err.bad_credentials": "Email or password is not right.",
  "err.too_many_attempts": "Too many attempts. Wait a minute.",
  "err.email_taken": "There is already an account with this email.",
  "err.name_taken": "That display name is taken.",
  "err.invalid_code": "That code is not valid.",
  "err.generic": "Something went wrong. Try again.",
  "err.invalid_email": "That is not a valid email address.",
  "err.invalid_input": "Check the fields: something is not filled in right.",

  "seed.title": "How well do you know combinations?",
  "seed.lead": "Pick one; the first ten exercises find your level.",
  "seed.new": "New to combinations",
  "seed.club": "Club player",
  "seed.strong": "Strong player",

  "train.white_to_play": "White to play",
  "train.placement": "Placement {i}/{n}",
  "train.second_chance": "Second chance",
  "train.review": "Review",
  "train.daily": "Exercise of the day",
  "train.taster": "Taster {i}/{n}",
  "train.black_also": "Black can also play {move}",
  "train.intro": "Black plays {move}",
  "train.lines": "Line {i} of {n}",
  "train.easier": "Easier",
  "train.normal": "Normal",
  "train.harder": "Harder",
  "train.give_up": "Show solution",
  "train.report": "Report a problem",
  "train.favorite": "Favorite",
  "train.unfavorite": "Remove favorite",
  "train.exhausted": "You have done every exercise here.",
  "train.exhausted_hint": "Review your mistakes, or open another module.",
  "train.mistakes_empty": "No mistakes are due. Well kept!",
  "train.favorites_empty": "No favorites yet. Star an exercise to add it.",
  "train.rating": "Rating {r}",
  "train.loading": "Setting up the board…",
  "train.sound": "Sound",
  "train.input": "Move input",
  "train.auto_next": "Next exercise automatically after solving",
  "train.all_labels": "All combinations ({n})",
  "train.label_done": "You have done every exercise labelled \u201c{label}\u201d.",
  "train.label": "Which combinations",
  "train.all": "All combinations",
  "train.label_search": "Find a label",
  "train.label_none": "No label matches.",

  "move.must_capture": "You must capture.",
  "move.most_pieces": "You must take the most pieces: {n} here.",
  "move.one_jump": "One jump at a time: click the square where your piece lands first.",
  "move.piece_first": "First click the piece you want to move.",
  "move.cannot_move": "This piece cannot move.",
  "move.finish_first": "Finish this capture, or press Esc to start again.",
  "move.choose": "Two ways to capture: click a piece you want to take.",
  "move.assist": "Assistance",
  "move.beginner": "Beginner - click every jump",
  "move.advanced": "Advanced - fewest clicks",
  "move.drag": "Allow dragging pieces",
  "move.targets": "Show possible moves",
  "train.mistakes": "Review mistakes",

  "result.solved_in": "Solved in {t}",
  "result.not_solved": "Not solved",
  "result.faster": "Faster than {p}% of players",
  "result.replay": "Replay",
  "result.next": "Next",
  "result.retry": "Try again",
  "result.show": "Show solution",
  "result.unrated": "Unrated",
  "result.exercise_rating": "Exercise {r}",
  "result.placement_done": "Your rating",

  "fb.not_this_time": "Not this time. The solution starts with {move}.",
  "fb.back_tomorrow": "We'll bring it back tomorrow.",
  "fb.above_level": "That one was above your level. Well found!",
  "fb.new_best": "New best: {rating}",
  "fb.streak": "{n} in a row ✦",
  "fb.first_theme": "First {theme}!",
  "fb.deep": "{n} moves deep - nicely calculated.",
  "fb.clean_quick": "Clean and quick.",
  "fb.solved_1": "Well played.",
  "fb.solved_2": "That's the one.",
  "fb.solved_3": "Neatly done.",
  "fb.solved_4": "Found it.",
  "fb.solved_5": "Right on target.",

  "ms.solved": "{n} solved",
  "ms.rating": "{rating} reached",
  "ms.module": "{title} completed",
  "ms.day_streak": "{n}-day streak",

  "level.beginner": "You are just starting out with combinations - the fun part is ahead.",
  "level.improving": "You spot the basic shots. Time to go deeper.",
  "level.club": "You solve combinations like a club player.",
  "level.strong_club": "You solve combinations like a strong club player.",
  "level.expert": "You calculate like an expert.",
  "level.master": "Master-level vision. Impressive.",

  "sol.title": "Solution",
  "sol.variations": "Variations",
  "sol.your_moves": "Your moves",
  "sol.main": "Main line",

  "report.title": "Report a problem",
  "report.other_solution": "Another move also wins",
  "report.wrong_solution": "The solution is wrong",
  "report.wrong_position": "The position is wrong",
  "report.other": "Something else",
  "report.text": "What did you notice?",
  "report.send": "Send",
  "report.thanks": "Thanks - we'll look at it.",

  "dash.greeting_morning": "Good morning, {name}",
  "dash.greeting_afternoon": "Good afternoon, {name}",
  "dash.greeting_evening": "Good evening, {name}",
  "dash.rating": "Rating",
  "dash.last7": "last 7 days",
  "dash.solved": "Solved",
  "dash.this_week": "+{n} this week",
  "dash.accuracy": "Accuracy 30 d",
  "dash.streak": "Streak",
  "dash.day": "{n} day",
  "dash.days": "{n} days",
  "dash.rating_chart": "Rating",
  "dash.activity": "Activity",
  "dash.by_theme": "By theme",
  "dash.train_theme": "Train",
  "dash.weekly": "Solved and failed per week",
  "dash.by_band": "By exercise rating",
  "dash.to_review": "To review: {n}",
  "dash.favorites": "Favorites: {n}",
  "dash.in_progress": "Modules in progress",
  "dash.start": "Start",
  "dash.open": "Open",
  "dash.placing": "Finish placement to see your rating.",
  "dash.empty": "Solve a few exercises and your progress shows up here.",
  "dash.accuracy_col": "Accuracy",
  "dash.time_col": "Avg time",
  "dash.solved_label": "solved",
  "dash.failed_label": "failed",

  "mod.title": "Modules",
  "mod.solved": "{s} / {n} solved",
  "mod.avg": "avg {r}",
  "mod.redeem": "Redeem code",
  "mod.redeem_ok": "Unlocked!",
  "mod.locked": "Locked",
  "mod.start": "Start",
  "mod.continue": "Continue",
  "mod.unrated": "unrated",
  "mod.course": "course",

  "fav.title": "Favorites",
  "fav.practice": "Practice favorites",
  "fav.sort_date": "Newest",
  "fav.sort_rating": "Rating",
  "fav.all_modules": "All modules",
  "fav.empty": "No favorites yet.",

  "hist.title": "History",
  "hist.all": "All results",
  "hist.solved_first": "Solved first try",
  "hist.solved_later": "Solved later",
  "hist.failed": "Failed",
  "hist.mastered": "Mastered",
  "hist.period_all": "All time",
  "hist.period_7": "7 days",
  "hist.period_30": "30 days",
  "hist.period_365": "1 year",
  "hist.empty": "Nothing here yet.",
  "hist.prev": "Previous",
  "hist.next": "Next",

  "lb.title": "Leaderboard",
  "lb.rating": "Rating",
  "lb.week": "This week",
  "lb.module": "Per module",
  "lb.all": "All",
  "lb.club": "My club",
  "lb.country": "My country",
  "lb.you": "You: #{rank} of {total}",
  "lb.empty": "Nobody here yet.",
  "lb.need_club": "Set your club in the profile first.",
  "lb.need_country": "Set your country in the profile first.",
  "lb.rating_rule": "Listed from 50 rated exercises, with a settled rating and activity in the last 30 days.",

  "prof.title": "Profile and settings",
  "prof.club": "Club",
  "prof.country": "Country (two letters)",
  "prof.sound": "Sounds",
  "prof.coords": "Board coordinates",
  "prof.board": "Board colours",
  "prof.board_wood": "Wood",
  "prof.board_green": "Green",
  "prof.board_blue": "Blue",
  "prof.theme": "Appearance",
  "prof.theme_system": "Follow system",
  "prof.theme_light": "Light",
  "prof.theme_dark": "Dark",
  "prof.language": "Language",
  "prof.hide": "Hide me from leaderboards",
  "prof.save": "Save",
  "prof.saved": "Saved.",
  "prof.password": "Change password",
  "prof.current": "Current password",
  "prof.data": "Your data",
  "prof.download": "Download my data",
  "prof.delete": "Delete account",
  "prof.delete_confirm": "Delete your account? Your attempts stay, anonymized, for the statistics.",

  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.loading": "Loading…",
  "common.seconds": "{n} s",
};

export default en;
export type Key = keyof typeof en;
